import type { FaireProductEntity } from "../../entity_types/product";

export const p_hq4thqn2wz: FaireProductEntity = {
  token: "p_hq4thqn2wz",
  type: "product",
  name: "Iodine Drops - Metabolism Support",
  brandToken: "b_5071j6eb6g",
  brandName: "NutraChamps",
  imageUrl:
    "https://cdn.faire.com/fastly/da525ad4b7acf7f44f7560f374fb3dd60d8a8f48120659b5dae2e5063f831a36.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/79b6a54cbfaf5587296b0f7a3163f5722af942bda093aa51a41ec4a3b63bf147.png",
    "https://cdn.faire.com/fastly/f472d94c0b94ccdc19d4bbbfad143436d7175955698007fdbdf5279b04347e14.png",
    "https://cdn.faire.com/fastly/2247bead18de269e15027d01ae78baafbc982035b0f7fed6e9fd78b4008aad8a.png",
    "https://cdn.faire.com/fastly/6e710c62a3cadbed3175e2c7633d64eae002343a5d733e6d3920e6ff581fdcff.png",
    "https://cdn.faire.com/fastly/cfaedd6a90ad79ba8f8c24d3d4d219a763c7e0f767324c712175727ccf553133.png",
    "https://cdn.faire.com/fastly/0dc2581cb7d6a190ee82c4da4769b93009d529c2ea7b3488fce0ccaa3e78d89e.jpeg",
  ],
  priceDollars: 16.59,
  description:
    "Energy, clarity, metabolism & balance - give your body what it needs. Iodine isn’t produced by the body, and so taking an iodine supplement is essential for many that don’t get enough in their diet. Iodine deficiencies can lead to exhaustion, weight gain, dry skin and even more issues that can be prevented. With just a couple flavorless drops each day, you’ll ensure your iodine levels are kept in check.\nHigh absorption & potency - nutrachamps’ premium iodine was scientifically designed in a highly concentrated liquid delivery system to maximize the amount of iodine that your body absorbs and utilizes. Its oral drops allow for super fast absorption so that you start reaping benefits virtually instantly upon use.",
  tags: [],
  msrpDollars: 27.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:45.002Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
